import axios from "axios";
import { formatAxiosErrorMessage } from "../api/httpError";
import { getAxiosBaseURL } from "../config/apiBase";

/**
 * Axios for public guest endpoints only. Never attach Authorization (secret links use query token).
 * Cookies not needed for GET viewTicketsGuest — omit credentials unless API requires CORS cookies.
 */
const guestAxios = axios.create({
  baseURL: getAxiosBaseURL(),
  headers: { "Content-Type": "application/json" },
  withCredentials: false,
});

guestAxios.interceptors.response.use(
  (response) => response?.data,
  (error) => {
    const message = formatAxiosErrorMessage(error);
    const err = new Error(message);
    err.status = error?.response?.status;
    err.response = error?.response;
    return Promise.reject(err);
  }
);

export default guestAxios;
